exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".language_container {\n  display: flex;\n  flex-direction: column;\n  margin-top: 2rem;\n}\n", ""]);

